import { render } from "./B2bTableLinesOrdersReceived.vue?vue&type=template&id=5d2e8d32&scoped=true&lang=pug"
import script from "./B2bTableLinesOrdersReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableLinesOrdersReceived.vue?vue&type=script&lang=js"

import "./B2bTableLinesOrdersReceived.vue?vue&type=style&index=0&id=5d2e8d32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2e8d32"]])

export default __exports__